import React, { useState, useEffect } from 'react';

import './styles.css';

import Card from '../../../../components/Card';
import BillsCardItem from './BillsCardItem';
import ActivityIndicator from '../../../../components/ActivityIndicator';
import Notice from '../../../../components/Notice';
import { FaArrowUp, FaArrowDown, FaFileInvoiceDollar, FaHistory, FaRegClock, FaFilter, FaPrint } from 'react-icons/fa';
import FilterBillsPopUp from './FilterBillsPopUp';
import reportServices from '../../../../services/reportServices';
import PopupReports from '../../../../components/PopupReports';

export default function BillsCard(props) {
    const [bills, setBills] = useState([]);
    const [billsToShow, setBillsToShow] = useState([]);


    const [visibilityFilter, setVisibilityFilter] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    let auxDate = new Date();

    useEffect(() => {
        if (props.bills) {
            let auxArray = props.bills;

            auxDate.setHours(auxDate.getHours() - (auxDate.getTimezoneOffset() / 60));

            if (props.toPay) auxArray = auxArray.filter((item) => item.tipo === "Pagar");
            else if (props.toReceive) auxArray = auxArray.filter((item) => item.tipo === "Receber");

            if (props.lateList) auxArray = auxArray.filter((item) => !item.paga && auxDate.toISOString().slice(0, 10) > item.data_venc);
            else if (props.todaysList) auxArray = auxArray.filter((item) => !item.paga && auxDate.toISOString().slice(0, 10) === item.data_venc);

            setBills(auxArray);
            setBillsToShow(auxArray);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.bills]);

    function selectId() {
        if (props.toPay) return "-to-pay";
        else if (props.toReceive) return "-to-receive";
        else return "";
    }

    // function selectTittle() {
    //     if (props.lateList) return <><FaHistory />Contas atrasadas - A {props.toPay ? "pagar" : "receber"}</>;
    //     else if (props.todaysList) return <><FaRegClock />Vencem hoje - A {props.toPay ? "pagar" : "receber"}</>;
    //     else if (props.toPay) return <><FaArrowUp />A pagar</>;
    //     else if (props.toReceive) return <><FaArrowDown />A receber</>;
    //     else return <><FaFileInvoiceDollar />Contas</>;
    // }

    function selectIcon() {
        if (props.lateList) return <FaHistory />;
        else if (props.todaysList) return <FaRegClock />;
        else if (props.toPay) return <FaArrowUp />;
        else if (props.toReceive) return <FaArrowDown />;
        else return <FaFileInvoiceDollar />;
    }

    function selectTittle() {
        if (props.lateList) return "Contas atrasadas";
        else if (props.todaysList) return "Vencem hoje";
        else if (props.toPay) return "A pagar";
        else if (props.toReceive) return "A receber";
        else return "Contas";
    }

    function selectSubtittle() {
        if (props.lateList || props.todaysList) {
            if (props.toPay) return "A pagar";
            else if (props.toReceive) return "A receber";
        }
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportAcademyBills(billsToShow, `RELATÓRIO DE CONTAS A ${props.toPay ? "PAGAR" : "RECEBER"}${props.lateList ? " ATRASADAS" : ""}${props.todaysList ? " QUE VENCEM HOJE" : ""}`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    return (
        <Card
            id={`bills${selectId()}-card`}
            className={"bills-card"}
            tittle={selectTittle()}
            icon={selectIcon()}
            subtittle={props.cardSubtittle ? props.cardSubtittle : selectSubtittle()}
            options={
                <>
                    {
                        props.lateList || props.todaysList ?
                            null :
                            <>
                                <button type='button' onClick={() => setVisibilityFilter(true)}>
                                    <FaFilter />
                                </button>
                                <FilterBillsPopUp
                                    visibility={visibilityFilter}
                                    setVisibility={setVisibilityFilter}
                                    bills={bills}
                                    setBills={setBillsToShow}
                                />
                            </>
                    }

                    <>
                        <button title="Gerar relatório" onClick={() => setVisibilityReport(true)}><FaPrint /></button>
                        <PopupReports
                            visibility={visibilityReport}
                            setVisibility={setVisibilityReport}
                            tittle="Relatório de Contas"
                            fields={reportServices.academyBillFields.filter(obj => {
                                if ((props.toReceive && obj.header !== "Fornecedor") || props.toPay && obj.header !== "Cliente") return true;
                                else return false;
                            })}
                            generateReport={generateReport}
                        />
                    </>

                    < span className={`tag medium ${props.toPay ? "red" : (props.toReceive ? "green" : "dark-blue")}`}>
                        {billsToShow.length} {billsToShow.length === 1 ? "conta" : "contas"}
                    </span>
                </>
            }
        >
            {
                props.lateList || props.todaysList ?
                    null :
                    <button
                        className={props.toPay ? "red" : (props.toReceive ? "green" : "")}
                        onClick={() => props.toPay ? props.onButtonClick("pagar") : (props.toReceive ? props.onButtonClick("receber") : props.onButtonClick())}
                    >
                        Adicionar conta{props.toPay ? " a pagar" : (props.toReceive ? " a receber" : "")}
                    </button>
            }

            {
                props.bills ?
                    billsToShow.length ?
                        <ul className='list'>
                            {
                                billsToShow.map((item, index) =>
                                    <BillsCardItem
                                        key={item.id}
                                        onClick={props.onItemClick ? () => props.onItemClick(item) : props.onItemClick}
                                        tittle={item.descricao}
                                        dueDate={item.data_venc}
                                        paydValue={item.valor_pago}
                                        value={item.valor_total}
                                        currency={item.moeda}
                                        payd={item.paga}
                                        isLate={auxDate.toISOString().slice(0, 10) > item.data_venc}
                                        expiresToday={auxDate.toISOString().slice(0, 10) === item.data_venc}
                                        code={item.id}
                                    />
                                )
                            }
                        </ul>
                        : (
                            props.lateList || props.todaysList ?
                                <Notice>Não há contas a serem listadas</Notice>
                                : []
                        )
                    : <ActivityIndicator />
            }
        </Card>
    )
}